import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";
import { DEFAULT_ITEMS_PER_PAGE, SORT_ORDER } from "../constants/common";

export default class FormService {
  static getLanguages(lang) {
    if (lang) {
      return HttpUtil.get(API_ROUTES.UTILS.LANGUAGE.replace("<ln>", lang));
    } else {
      return HttpUtil.get(API_ROUTES.UTILS.LANGUAGE.replace("?key=<ln>", ""));
    }
  }
  static listForms(
    pageNumber = 0,
    pageSize = DEFAULT_ITEMS_PER_PAGE,
    key,
    sort
  ) {
    if (key) {
      return HttpUtil.get(
        API_ROUTES.FORMS.LISTFORMS.replace("<pageNumber>", pageNumber)
          .replace("<pageSize>", pageSize)
          .replace("<key>", key)
          .replace("<sort>", sort)
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.FORMS.LISTFORMS.replace("<pageNumber>", pageNumber)
          .replace("<pageSize>", pageSize)
          .replace("&key=<key>", "")
          .replace("<sort>", sort)
      );
    }
  }
  static createForm(params) {
    return HttpUtil.post(API_ROUTES.FORMS.CREATEFORM, params);
  }
  static updateForm(formId, params) {
    return HttpUtil.put(
      API_ROUTES.FORMS.UPDATEFORM.replace("<formId>", formId),
      params
    );
  }
  static renameForm(formId, params) {
    return HttpUtil.put(
      API_ROUTES.FORMS.UPDATEFORM.replace("<formId>", formId),
      params
    );
  }
  static shareForm(formId, token, params, isOpenForm = false) {
    if (isOpenForm) {
      return HttpUtil.post(
        API_ROUTES.FORMS.SHARE_OPEN_FORM
        .replace("<formId>", formId)
        .replace("<token>",token),
        params
      );
    } else {
      return HttpUtil.post(
        API_ROUTES.FORMS.SHAREFORM.replace("<formId>", formId).replace(
          token ? "<token>" : "?token=<token>",
          token
        ),
        params
      );
    }   
  }
  static sharedWithDetails(formId, token = '', isOpenForm = false) {
    if (isOpenForm) {
      return HttpUtil.get(
        API_ROUTES.FORMS.SHARED_WITH_FOR_OPEN_FORM
        .replace("<formId>", formId)
        .replace("<token>", token),
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.FORMS.SHAREDWITH
        .replace("<formId>", formId)
        .replace(token ? "<token>" : "?token=<token>",token),
      );
    }
    
  }

  static formatDate = (dateString) => {
    console.log('dateString',dateString)
    const options = { year: "numeric", month: "long", day: "numeric"}
    return new Date(dateString).toLocaleDateString(undefined, options)
  }

  static getCompanyBranches(tenantId = 1, companyId = 0) {
    return HttpUtil.get(
      API_ROUTES.TENANT.LIST_COMPANY_BRANCHES
      .replace("<tenantId>", tenantId)
      .replace("<companyId>", companyId)
    );
  }

  static getUnitsOfMeasure(companyId = 0) {
    return HttpUtil.get(API_ROUTES.UTILS.GET_UNITS_OF_MEASURE
    .replace(companyId > 0 ? '<companyId>' : '?companyId=<companyId>' , companyId > 0 ? companyId : ''));
  }

  static getSharedDetails(token) {
    return HttpUtil.get(
      API_ROUTES.FORMS.GET_SHARED_DETAILS.replace("<token>", token)
    );
  }

  static getSkeletonForReview(token) {
    return HttpUtil.get(
      API_ROUTES.FORMS.GET_SKELETON_FOR_REVIEW.replace("<token>", token)
    );
  }

  static getSubmittedDataForReview(token) {
    return HttpUtil.get(
      API_ROUTES.FORMS.GET_SUBMITTED_DATA_FOR_REVIEW.replace("<token>", token)
    );
  }

  static saveReviewComment(token, responseId, payload, isInReview = true) {
    if (isInReview) {
      return HttpUtil.post(
        API_ROUTES.REVIEW_COMMENT.SAVE
        .replace("<token>", token)
        .replace("<responseId>", responseId),
        payload
      );
    } else {
      return HttpUtil.post(
        API_ROUTES.REVIEW_COMMENT.SAVE_FOR_DATA_OWNER
        .replace("<token>", token)
        .replace("<responseId>", responseId),
        payload
      );
    }
  }

  static getReviewComments(token, isInReview =  true) {
    if (isInReview) {
      return HttpUtil.get(
        API_ROUTES.REVIEW_COMMENT.GET_WITH_REVIEW_TOKEN.replace("<token>", token)
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.REVIEW_COMMENT.GET_WITH_FORM_ACCESS_TOKEN.replace("<token>", token)
      );
    }    
  }

  static approveSubmission(token) {
    return HttpUtil.patch(
      API_ROUTES.FORMS.APPROVE_FORM_SUBMISSION
      .replace("<token>", token)
    );
  }

  static rejectSubmission(token) {
    return HttpUtil.patch(
      API_ROUTES.FORMS.REJECT_FORM_SUBMISSION
      .replace("<token>", token),
      {}
    );
  }

  static getOCRData(payload) {
    return HttpUtil.postWithFileOCR(
      API_ROUTES.OCR.GET_OCR_DATA,
      payload
    );
  }

  static getOCRProgress(jobId) {
    return HttpUtil.getOCRProgress(
      API_ROUTES.OCR.GET_OCR_PROGRESS.replace("<jobId>", jobId)
    );
  }
}
